import React from "react";
import styles from "./Progress.module.scss";

const Progress = ({ value }) => (
	<div className={styles.host}>
		<div className={styles.progress} style={{ width: `${value || 0}%` }} />
	</div>
);

export default Progress;
